<section class="bg-[#E7F1FF] min-h-screen flex flex-col">
    <button
        class="absolute top-8 left-2 md:left-8 w-11 h-11 bg-[#3461AF] rounded-full flex items-center justify-center cursor-pointer border-none outline-none"
        title="Back">
        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M8.70711 0.793382C9.09763 1.18391 9.09763 1.81707 8.70711 2.2076L3.41421 7.50049H15C15.5523 7.50049 16 7.9482 16 8.50049C16 9.05277 15.5523 9.50049 15 9.50049H3.41421L8.70711 14.7934C9.09763 15.1839 9.09763 15.8171 8.70711 16.2076C8.31658 16.5981 7.68342 16.5981 7.29289 16.2076L0.292893 9.20759C-0.0976311 8.81707 -0.0976311 8.18391 0.292893 7.79338L7.29289 0.793382C7.68342 0.402857 8.31658 0.402857 8.70711 0.793382Z"
                fill="white" />
        </svg>
    </button>
    <div class="flex flex-col items-center justify-between relative pt-5 lg:pt-5 xl:pt-5 2xl:pt-24">
        <div class="flex flex-col mb-20 lg:mb-10 xl:mb-10 2xl:mb-20">
            <img src="/assets/logo-horizontal.png" alt="Royal Hospital Logo">

        </div>
        <div class="flex-grow flex flex-col justify-center relative mb-20 lg:mb-10 xl:mb-10 2xl:mb-20">
            <img src="/assets/login-background.png" alt="" class="absolute inset-0 w-full h-full object-cover mt-48">
            <div class="relative z-10">
                <div class="flex justify-center items-center h-full">
                    <div class="bg-white rounded-xl px-8 pb-8 w-[300px] lg:w-[420px]">
                        <h2 class="text-2xl font-bold text-[#3E4A58] mb-4 text-start">Reset Password</h2>
                        <form class="space-y-4" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
                            <label tuiLabel>
                                <tui-input-password formControlName="newPassword" style="margin-bottom: 10px;">
                                    New Password <input tuiTextfieldLegacy type="password" />
                                </tui-input-password>
                                <p class="text-red-600 pt-0 mt-0" *ngIf="resetPasswordForm.get('newPassword')?.touched">
                                    {{ getPasswordError() }}
                                </p>
                            </label>

                            <label tuiLabel>
                                <tui-input-password formControlName="confirmPassword" style="margin-bottom: 10px;">
                                    Confirm Password <input tuiTextfieldLegacy type="password" />
                                </tui-input-password>
                                <p class="text-red-600 pt-0 mt-0"
                                    *ngIf="resetPasswordForm.get('confirmPassword')?.touched">
                                    {{ getConfirmPasswordError() }}
                                </p>
                            </label>

                            <button appearance="primary" tuiButton type="submit"
                                class="w-full bg-[#285CA5] text-white text-base font-bold py-4 rounded-xl border-none outline-none">
                                <span *ngIf="isLoading"
                                    class="h-4 w-4 rounded-full border-2 border-white/40 border-t-white animate-spin"
                                    aria-hidden="true"></span>
                                <span>{{ isLoading ? "Resetting..." : "Submit" }}</span>
                            </button>
                        </form>

                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-col items-center">
            <img src="/assets/purple-logo.png" alt="Purple Software Logo">
            <p class="font-bold text-xs text-[#64748B]">
                Powered by <span class="text-[#6C066D]">Purple Software</span>
            </p>
        </div>
    </div>

</section>